import { Injectable } from '@angular/core';
import FingerPrint, { Agent } from '@fingerprintjs/fingerprintjs';

@Injectable({
  providedIn: 'root',
})
export class FingerprintService {
  private agent: Agent = null;

  async init() {
    this.agent = await FingerPrint.load();
  }

  async getVisitorId() {
    if (!this.agent) {
      return null;
    }

    const { visitorId } = await this.agent.get();
    return visitorId;
  }
}
